var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecommend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 54,
    viewBox: "0 0 66 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 3H63M3 27H19.5M3 51H19.5",
    stroke: "#018C0D",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.25 43.5C47.6315 43.5 50.8745 42.1567 53.2656 39.7656C55.6567 37.3745 57 34.1315 57 30.75C57 27.3685 55.6567 24.1255 53.2656 21.7344C50.8745 19.3433 47.6315 18 44.25 18C40.8685 18 37.6255 19.3433 35.2344 21.7344C32.8433 24.1255 31.5 27.3685 31.5 30.75C31.5 34.1315 32.8433 37.3745 35.2344 39.7656C37.6255 42.1567 40.8685 43.5 44.25 43.5Z",
    stroke: "#018C0D",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.5 40.5L63 51.075",
    stroke: "#018C0D",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommend);
export default __webpack_public_path__ + "static/media/recommend.63e2747387bdda200eff9952970a5e86.svg";
export { ForwardRef as ReactComponent };